var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('p',{staticClass:"text-center"},[_vm._v("Copyright © 2026, Lyn Pearce. All Rights Reserved.")])])
}]

export { render, staticRenderFns }